'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _rx = require('rx');

var _createEventString = require('./createEventString');

var _createEventString2 = _interopRequireDefault(_createEventString);

var _createRequestStream = require('./createRequestStream');

var _createRequestStream2 = _interopRequireDefault(_createRequestStream);

var _splitByMaxUrlSize = require('./splitByMaxUrlSize');

var _splitByMaxUrlSize2 = _interopRequireDefault(_splitByMaxUrlSize);

var _createDefaultStore = require('./createDefaultStore');

var _createDefaultStore2 = _interopRequireDefault(_createDefaultStore);

var _createDefaultQueue = require('./createDefaultQueue');

var _createDefaultQueue2 = _interopRequireDefault(_createDefaultQueue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var TIMED_REQUEST_INTERVAL = 5000;

exports.default = function (trackingPath) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$store = options.store;
  var store = _options$store === undefined ? (0, _createDefaultStore2.default)() : _options$store;
  var _options$queue = options.queue;
  var queue = _options$queue === undefined ? (0, _createDefaultQueue2.default)() : _options$queue;
  var _options$send = options.send;
  var send = _options$send === undefined ? function (_ref) {
    var url = _ref.url;
    var params = _ref.params;
    return _axios2.default.get(url, { params: params });
  } : _options$send;
  var _options$subscriber = options.subscriber;
  var subscriber = _options$subscriber === undefined ? function () {} : _options$subscriber;
  var params = options.params;


  var requestStream = (0, _createRequestStream2.default)(trackingPath, { send: send, params: params });

  // Pull events out of the store (localstorage probably), which is slow, and maintain
  // the values till we leave the page.
  store.swap(function (entries) {
    (entries || []).forEach(function (event) {
      queue.add(event);
    });

    return [];
  });

  // When we leave the page, put the events back onto the slow store (localstorage probably).
  var serialize = function serialize() {
    store.swap(function (entries) {
      var unserializedEntries = (entries || []).slice(0);

      unserializedEntries.push.apply(unserializedEntries, _toConsumableArray(queue.removeAll()));
      return unserializedEntries;
    });
  };

  var flushBuffer = function flushBuffer(tBuffer) {
    return _rx.Observable.return(tBuffer).concatMap(_splitByMaxUrlSize2.default).filter(function (x) {
      return x.length;
    }).map(function (x) {
      return x.join(';');
    }).flatMap(requestStream);
  };

  _rx.Observable.interval(TIMED_REQUEST_INTERVAL, _rx.Scheduler.default).flatMap(function () {
    return flushBuffer(queue.removeAll());
  }).subscribe(subscriber);

  var flushTrackingBuffer = function flushTrackingBuffer() {
    return flushBuffer(queue.removeAll()).toPromise(Promise);
  };

  var trackJobImpression = function trackJobImpression(token) {
    return queue.add((0, _createEventString2.default)({ token: token, type: 'searchImpression' }));
  };

  var trackJobImpressionExit = function trackJobImpressionExit(token) {
    return queue.add((0, _createEventString2.default)({ token: token, type: 'searchImpressionExit' }));
  };

  var trackJobClick = function trackJobClick(token) {
    return queue.add((0, _createEventString2.default)({ token: token, type: 'searchResultSelected_2' }));
  };

  return {
    trackJobImpression: trackJobImpression,
    trackJobImpressionExit: trackJobImpressionExit,
    trackJobClick: trackJobClick,
    forceTrackingRequest: flushTrackingBuffer,
    serializeUnsentImpressions: serialize
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/index.js
 ** module id = 16
 ** module chunks = 0
 **/